<template>
  <div class="roleTree">
    <div class="roleTree__header">
      <el-input v-model="searchFactor" placeholder="请输入角色" size="small">
        <template #prefix><i class="el-icon-search el-input__icon" /></template>
      </el-input>
      <slot></slot>
    </div>
    <div class="roleTree__body" v-loading="treeLoading">
      <el-tree
        ref="roletree"
        :data="roleList"
        default-expand-all
        highlight-current
        node-key="roleID"
        @node-click="selectNode"
        :render-content="renderContent"
        :props="defaultProps"
      >
      </el-tree>
    </div>

    <el-dialog title="编辑角色" :visible.sync="roleDialog" width="400px">
      <div class="submitForm" v-loading="roleDialogLoading">
        <span class="label">请输入角色名称</span>
        <el-input
          size="small"
          v-model="currentRole.roleName"
          placeholder=""
          maxlength="30"
          show-word-limit
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleDialog = false">取 消</el-button>
        <el-button type="primary" @click="updateRole">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

import service from "@/xgzdService/setting-service";
import { promiseWrapper } from "@/utils/wrapper";
const initialCurrentRole = () => ({
  roleName: "",
  roleId: "",
});
export default {
  data: () => {
    return {
      searchFactor: "",
      roleList: [],
      treeLoading: false,
      defaultProps: { children: "childList", label: "roleName" },
      currentSelectRoleID: "",
      currentSelectCataID: "",
      roleDialog: false,
      currentRole: initialCurrentRole(),
      roleDialogLoading: false,
    };
  },
  props: {
    enableModifiy: {
      default: () => false,
      type: Boolean,
    },
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
    }),
  },
  methods: {
    async getTreeInfo() {
      this.treeLoading = true;
      let res = await promiseWrapper(
        service.getPrjRoleTree(this.enterpriseId),
        // service.getPrjRoleTree(),
        "[获取项目角色树]"
      );
      this.treeLoading = false;
      this.treeDataProcessor(res?.data);
    },

    treeDataProcessor(data) {
      let fakeData = Array.isArray(data) ? data : [];
      fakeData.forEach((item) => {
        item.isCata = true; // 标记一级节点
        item.$isOperation = "1"; // 也是标记当前节点是一级节点的意思只是为了兼容一些旧页面
      });
      this.roleList = fakeData;
    },
    selectNode(node) {
      if (node.isCata) {
        this.currentSelectRoleID = "";
        this.currentSelectCataID = node.roleID;
      } else {
        this.currentSelectRoleID = node.roleID;
        this.currentSelectCataID = "";
      }
      if ("node-click" in this.$listeners) {
        this.$emit("node-click", node);
      }
    },
    renderContent(h, { node, data, store }) {
      const disableRoleNames = [
        "项目总负责人",
        "项目经理",
        "项目管理员",
        "项目负责人",
      ];
      const disableCategoryNames = ["项目管理"];
      const selected = node.data.isCata
        ? this.currentSelectCataID
        : this.currentSelectRoleID;
      const _this = this;
      const canBeInject =
        selected === node.data.roleID &&
        ((!disableRoleNames.includes(node.data.roleName) &&
          !node.data.isCata) ||
          (!disableCategoryNames.includes(node.data.roleName) &&
            !!node.data.isCata)) &&
        this.enableModifiy;
      let inject = canBeInject
        ? [
            h(
              "div",
              {
                attrs: {
                  class: "roleMaintain",
                },
              },
              [
                h("img", {
                  attrs: {
                    src: require("@/xgzdAssets/permission/edit.svg"),
                  },
                  on: {
                    click: function () {
                      return _this.editNode(node.data);
                    },
                  },
                }),
                h("img", {
                  attrs: {
                    src: require("@/xgzdAssets/permission/delete.svg"),
                  },
                  on: {
                    click: function () {
                      return _this.delNode(node.data);
                    },
                  },
                }),
              ]
            ),
          ]
        : [];

      return h(
        "div",
        {
          attrs: {
            class: "treenodeManual",
          },
        },
        [
          h("img", {
            attrs: {
              src: node.data.isCata
                ? require("@/xgzdAssets/permission/class.svg")
                : require("@/xgzdAssets/permission/role.svg"),
            },
          }),
          h("div", {
            domProps: {
              innerHTML: node.data.isCata
                ? node.label
                : this.highLightSearchedText(node.label),
            },
            attrs: {
              class: "ellipsis infoText",
              title: node.label,
            },
          }),
          ...inject,
        ]
      );
    },

    highLightSearchedText(text) {
      text = text || "";
      text = text.replaceAll(
        this.searchFactor,
        `<span style="color:#3873fe;">${this.searchFactor}</span>`
      );
      return text;
    },
    async editNode(data) {
      !!data.isCata ? this.editCategory(data) : this.editRole(data);
    },

    editRole(data) {
      this.currentRole.roleName = data?.roleName;
      this.currentRole.roleId = data?.roleID;
      this.roleDialog = true;
    },

    editCategory(data) {
      if ("editCategory" in this.$listeners) {
        this.$emit("editCategory", data, () => this.getTreeInfo());
      } else {
        console.warn(
          "[warn] parent component of <role-tree> need pass a method named 'editCategory'"
        );
      }
    },

    delNode(data) {
      !!data?.isCata ? this.delCategory(data) : this.delRole(data);
    },
    async delRole(data) {
      this.treeLoading = true;
      const res = await promiseWrapper(service.deleteRole(data.roleID));
      this.treeLoading = false;
      if (res.result == "0") {
        this.$message.success("删除角色成功");
        this.getTreeInfo();
      }
    },
    async delCategory(data) {
      this.treeLoading = true;
      const res = await promiseWrapper(service.deleteClass(data.roleID));
      this.treeLoading = false;
      if (res.result == "0") {
        this.$message.success("删除分类成功");
        this.getTreeInfo();
      }
    },

    async updateRole() {
      this.roleDialogLoading = true;
      const res = await promiseWrapper(
        service.updateRole({
          ...this.currentRole,
        }),
        "[更新系统角色信息]"
      );
      this.roleDialogLoading = false;
      if (res.result == "0") {
        this.$message.success("更新角色成功");
        this.currentRole = initialCurrentRole();
        this.getTreeInfo();
      }
      this.roleDialog = false;
    },
  },
  created() {
    this.getTreeInfo();
  },
};
</script>

<style lang="scss" scoped>
.submitForm {
  min-height: 100px;
  padding: 2px 10px 0px 10px;
  box-sizing: border-box;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  > span.label {
    margin: 20px 0px 5px 0px;
  }
  * {
    font-weight: 300 !important;
  }
}
.roleTree {
  user-select: none;
  $rt_height: 40px;
  height: 100%;
  width: 100%;
  > * {
    width: 100%;
  }
  &__header {
    height: $rt_height;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    border-bottom: 1px solid #f4f5fa;
    /deep/ .el-input {
      margin: 0px 5px;
    }
  }
  &__body {
    $scale_size: 14px;
    padding-top: 5px;
    height: calc(100% - #{$rt_height});
    overflow: hidden auto;
    /deep/ .el-tree {
      .treenodeManual {
        display: grid;
        grid-template-columns: 20px 1fr 40px;
        width: 100%;
        overflow: hidden;
        align-items: center;
        justify-content: center;
        > img {
          margin-right: 4px;
          height: $scale_size;
          width: $scale_size;
        }
        .infoText {
          font-family: "PingFang SC";
          font-style: normal;
          color: #303133;
          line-height: 20px;
          font-size: $scale_size !important;
        }
      }
      .roleMaintain {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        justify-content: flex-start;
        img {
          margin: 0 3px;
          height: $scale_size;
          width: $scale_size;
        }
      }
    }
  }
}
</style>